// Component: Checkbox.jsx
// Purpose: DS checkbox — `.ds-checkbox` box + check, accent when on. Controlled
//   (checked / onChange). Renders as a role="checkbox" button for a11y.

import React from "react";
import { cx } from "./cx";

export function Checkbox({ checked = false, onChange, label, disabled, className, ...props }) {
  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange?.(!checked)}
      className={cx("ds-checkbox", className)}
      {...props}
    >
      <span className={cx("ds-checkbox-box", checked && "on")} />
      {label != null && <span>{label}</span>}
    </button>
  );
}

export default Checkbox;
